var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapmarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4a494a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.861,0a5.851,5.851,0,0,0-6,5.69c0,3.143,4.712,9.31,6,9.31.952,0,6-6.167,6-9.31a5.852,5.852,0,0,0-6-5.69ZM9.834,8.49A2.972,2.972,0,0,1,6.786,5.6,2.972,2.972,0,0,1,9.834,2.708,2.972,2.972,0,0,1,12.882,5.6,2.972,2.972,0,0,1,9.834,8.49Z",
    transform: "translate(-3.862 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapmarker);
export default __webpack_public_path__ + "static/media/mapmarker.6c3653b0.svg";
export { ForwardRef as ReactComponent };